import usersLearningNavTemplate from './nav/template.html';
import usersLearningNavCtrl from './nav';
import usersLearningActivitiesTemplate from './activities/template.html';
import usersLearningActivitiesCtrl from './activities';
import usersLearningCoursesTemplate from './courses/template.html';
import usersLearningCoursesCtrl from './courses';
import usersLearningEventsTemplate from './events/template.html';
import usersLearningEventsCtrl from './events';
import usersLearningTracksTemplate from './tracks/template.html';
import usersLearningTracksCtrl from './tracks';

const usersLearningState = {
  url: '/learning',
  stateName: 'Learning Plan',
  abstract: true,
  data: {
    specialClass: 'fixed-sidebar'
  },
  views: {
    'a@app': {
      template: usersLearningNavTemplate,
      controller: usersLearningNavCtrl,
      controllerAs: 'UsersLearningNavCtrl'
    }
  }
};

const usersLearningActivitiesState = {
  url: '/activities?tab',
  stateName: 'Activities',
  reloadOnSearch: false,
  data: {
    specialClass: 'fixed-sidebar'
  },
  resolve: {
    ResolveClass: 'ResolveClass',
    authenticateCompany: /* @ngInject */ ResolveClass =>
      ResolveClass.authenticateCompany('/learning/activities')
  },
  views: {
    'b@app': {
      template: usersLearningActivitiesTemplate,
      controller: usersLearningActivitiesCtrl,
      controllerAs: 'UsersLearningActivitiesCtrl'
    }
  }
};

const usersLearningCoursesState = {
  url: '/courses?tab',
  stateName: 'Courses',
  reloadOnSearch: false,
  data: {
    specialClass: 'fixed-sidebar'
  },
  views: {
    'b@app': {
      template: usersLearningCoursesTemplate,
      controller: usersLearningCoursesCtrl,
      controllerAs: 'UsersLearningCoursesCtrl'
    }
  }
};

const usersLearningEventsState = {
  url: '/events?tab',
  stateName: 'Events',
  reloadOnSearch: false,
  data: {
    specialClass: 'fixed-sidebar'
  },
  views: {
    'b@app': {
      template: usersLearningEventsTemplate,
      controller: usersLearningEventsCtrl,
      controllerAs: 'UsersLearningEventsCtrl'
    }
  }
};

const usersLearningTracksState = {
  url: '/track?track&page&pageSize',
  stateName: 'Learning Tracks',
  reloadOnSearch: false,
  data: {
    specialClass: 'fixed-sidebar'
  },
  resolve: {
    ResolveClass: 'ResolveClass',
    authenticateCompany: /* @ngInject */ ResolveClass =>
      ResolveClass.authenticateCompany('/learning/trackId')
  },
  params: {
    page: {
      type: 'int',
      value: undefined
    },
    pageSize: {
      type: 'int',
      value: undefined
    },
    track: {
      value: undefined,
      type: 'string'
    }
  },
  views: {
    'b@app': {
      template: usersLearningTracksTemplate,
      controller: usersLearningTracksCtrl,
      controllerAs: 'UsersLearningTracksCtrl'
    }
  }
};

export {
  usersLearningState,
  usersLearningActivitiesState,
  usersLearningCoursesState,
  usersLearningEventsState,
  usersLearningTracksState
};



// WEBPACK FOOTER //
// ./src/app/controllers/users/learning/index.js